module.exports = function (_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$signature = _ref.signature,
    signature = _ref$signature === void 0 ? '' : _ref$signature,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$blockId = _ref.blockId,
    blockId = _ref$blockId === void 0 ? '' : _ref$blockId,
    _ref$blockHash = _ref.blockHash,
    blockHash = _ref$blockHash === void 0 ? '' : _ref$blockHash,
    _ref$blockHref = _ref.blockHref,
    blockHref = _ref$blockHref === void 0 ? '' : _ref$blockHref,
    _ref$blockInput = _ref.blockInput,
    blockInput = _ref$blockInput === void 0 ? '' : _ref$blockInput,
    _ref$transactionId = _ref.transactionId,
    transactionId = _ref$transactionId === void 0 ? '' : _ref$transactionId,
    _ref$longestChain = _ref.longestChain,
    longestChain = _ref$longestChain === void 0 ? '' : _ref$longestChain,
    _ref$createdAt = _ref.createdAt,
    createdAt = _ref$createdAt === void 0 ? '' : _ref$createdAt;
  var statusHtml = '';
  if (loading) {
    statusHtml = "<p class=\"explorer-address-status\">Looking up transaction\u2026</p>";
  } else if (error) {
    statusHtml = "\n      <div class=\"explorer-teaser-loading explorer-teaser-error\">\n        <p class=\"explorer-teaser-loading-title\">Unable to look up transaction</p>\n        <p class=\"explorer-teaser-loading-message\">".concat(error, "</p>\n      </div>\n    ");
  }
  var statusSlug = status ? status.toLowerCase().replace(/\s+/g, '-') : '';
  var statusPanel = status && !loading ? "\n      <div class=\"explorer-utxo-status-panel explorer-utxo-status-".concat(statusSlug, "\" role=\"status\">\n        <p class=\"explorer-utxo-status-value\">").concat(status, "</p>\n      </div>\n    ") : '';
  var visitBlockHtml = blockHref && blockInput ? "\n      <p class=\"explorer-utxo-block-visit\">\n        <a href=\"".concat(blockHref, "\" class=\"explorer-link explorer-utxo-block-link\" data-block-input=\"").concat(blockInput, "\">visit the block containing this transaction...</a>\n      </p>\n    ") : '';
  var fields = [];
  if (!loading && !error && status && status !== 'NOT FOUND' && status !== 'UNCONFIRMED') {
    fields.push({
      label: 'block id',
      value: blockId || '—'
    });
    fields.push({
      label: 'block hash',
      value: blockHash || '—',
      valueClass: 'explorer-tx-meta-value-mono'
    });
    fields.push({
      label: 'transaction id',
      value: transactionId || '—'
    });
    fields.push({
      label: 'longest chain',
      value: longestChain || '—'
    });
    fields.push({
      label: 'created',
      value: createdAt || '—'
    });
  }
  var fieldsHtml = fields.length ? "\n      <dl class=\"explorer-tx-meta explorer-utxo-fields\">\n        ".concat(fields.map(function (field) {
    return "\n          <dt class=\"explorer-tx-meta-label\">".concat(field.label, ":</dt>\n          <dd class=\"explorer-tx-meta-value ").concat(field.valueClass || '', "\">").concat(field.value, "</dd>\n        ");
  }).join(''), "\n      </dl>\n    ") : '';
  return "\n    <main class=\"explorer-content explorer-view-panel explorer-address-page explorer-utxo-page\">\n      <div class=\"explorer-container explorer-stack\">\n        <div class=\"explorer-address-header\">\n          <button type=\"button\" class=\"explorer-back-link\" data-nav=\"home\" aria-label=\"Back to explorer home\">\n            <i class=\"fa-solid fa-arrow-left\"></i>\n          </button>\n          <div class=\"explorer-address-header-text\">\n            <h1 class=\"explorer-page-title\">Transaction</h1>\n            ".concat(signature ? "<p class=\"explorer-address-key-raw explorer-mono\">".concat(signature, "</p>") : '', "\n          </div>\n        </div>\n\n        <div class=\"explorer-address-dashboard explorer-card explorer-card-padded\">\n          ").concat(visitBlockHtml, "\n          ").concat(statusHtml, "\n          ").concat(statusPanel, "\n          ").concat(fieldsHtml, "\n        </div>\n      </div>\n    </main>\n  ");
};